// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3QdTX","Label":"BuildControl_Label__30l8I","More":"BuildControl_More__2G9VC","Less":"BuildControl_Less__14d9c"};